module.exports = __webpack_public_path__ + "static/img/reward2.df770df3.png";